import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Divider, Toolbar, Link, Button, Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { useSelector, useAppDispatch } from 'store';
import { actions } from 'slices/auth';
import LanguagePopover from './LanguagePopover';
import NavItems from './NavItems';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logo: {
      height: 34,
      marginRight: 20,
      position: 'relative',
      top: '2px',
      [theme.breakpoints.down(440)]: {
        marginRight: 15,
        marginLeft: -4,
        height: 30,
      },
    },
    logo2: {
      height: 34,
      marginRight: 20,
      [theme.breakpoints.down(440)]: {
        height: 30,
      },
    },
  })
);

const MainNavbar = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const user = useSelector((state) => state.auth.user);


  // // // const openSignupModal = () => {
  // // //   dispatch(actions.toggleSignupModal(true));
  // // // };

  // // // const openLoginModal = () => {
  // // //   dispatch(actions.toggleLoginModal(true));
  // // // };

  return (
    <AppBar
      elevation={0}
      sx={{
        backgroundColor: 'background.paper',
        color: 'text.primary',
      }}
      role="header"
    >
      <Box paddingX={3}>
        <Toolbar disableGutters sx={{ height: 80 }}>
          <Box display="flex">
            <Link component={RouterLink} to="/" sx={{ lineHeight: 1 }}>
              <img
                alt="ecampus"
                src="/static/ecampus-logo-purple.svg"
                className={classes.logo}
              />
            </Link>
            <img
              alt="ecampus"
              src="/static/central-virtual2.svg"
              className={classes.logo2}
            />
          </Box>
          <NavItems />
          <LanguagePopover />
          {!user && (
            <>
              <Box
                sx={{
                  display: 'flex',
                  '@media screen and (max-width: 767px)': {
                    backgroundColor: 'white',
                    padding: '16px 0',
                    position: 'absolute',
                    left: '-24px',
                    top: '80px',
                    width: 'calc(100% + 48px)',
                    justifyContent: 'center',
                    borderTop: '1px solid #E9E8EB',
                  },
                }}
              >

                <a href="https://can01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fforms.office.com%2Fpages%2Fresponsepage.aspx%3Fid%3D7w5psxIAQk2Gy3nB26xWPcYPVwwQo_hOgA6Baue07-hUMkFTQ0RBOFJSQ1Y5MkEyRjZTMEhBOTRWQy4u%26route%3Dshorturl&data=05%7C02%7Cvrajkumar%40ecampusontario.ca%7Cdfe31540542043f1da5408de130c4505%7Cb3690eef00124d4286cb79c1dbac563d%7C0%7C0%7C638969140594091676%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C4000%7C%7C%7C&sdata=0mZF6KnOU2CW2Nb86J%2BlsexJ9mBq5d%2Ba0vOFy9Nco8Y%3D&reserved=0" target="_blank">
                  <Button
                  variant="text"
                  color="primary"
                  sx={{
                    marginX: 1,
                  }} 
                >
                  {t('navigation.joinBtn')}
                </Button></a>

                {/* <Button
                  variant="text"
                  color="primary"
                  sx={{
                    marginX: 1,
                  }}
                  onClick={openSignupModal}
                >
                  {t('navigation.joinBtn')}
                </Button> */}
                {/* <Button
                  variant="contained"
                  color="primary"
                  disableRipple
                  disableFocusRipple
                  disableTouchRipple
                  onClick={openLoginModal}
                  sx={{ whiteSpace: 'nowrap' }}
                >
                  {t('navigation.loginBtn')}
                </Button> */}
              </Box>
            </>
          )}
        </Toolbar>
      </Box>
    </AppBar>
  );
};
export default MainNavbar;
